import classNames from 'classnames';
import type { FC, PropsWithChildren } from 'react';
import { memo } from 'react';

import type { TabStyles } from './ProfileTab';

const tabClassesConfig: Record<TabStyles, string> = {
  pages: 'border-blue-200',
  comments: 'border-blue-250',
  rewards: 'border-yellow-200',
  friends: 'border-red-300',
  preferences: 'border-gray-500',
} as const;

interface Prop {
  styles: keyof typeof tabClassesConfig;
}

export const ProfileTabs: FC<PropsWithChildren<Prop>> = memo(function ProfileTabs(props) {
  const { styles: stylesKey, children } = props;

  const classes = tabClassesConfig[stylesKey];

  return (
    <div
      className={classNames(
        'list-none flex justify-center xs:text-[11px] sm:text-[12px] md:text-[13px] lg:text-[14px] border-b-2 border-solid',
        classes,
      )}
      id="profile-menu-section"
    >
      <div className="flex space-x-1 grow">{children}</div>
    </div>
  );
});
